export const TRANSLATIONS_EN = {
  HELLO_DEALER: ' Hello Dealers !',
  ADD_EDIT_OFFERS_TIPS_MODAL_TITLE: 'Upload file',
  SEND_ALERT_MODAL_TITLE: 'Upload CSV file',
  POSTER_SUBTITLE: 'We are on a mission to help clients to provide best deals for cars and more..!',
  DEALER_KER: 'Dealer Ker',
  SIGN_IN: 'Sign In',
  SIGN_IN_SUBTITLE: 'Sign in to stay connected.',
  EMAIL: 'Email',
  PASSWORD: 'Password',
  ENTER_USERNAME: 'Enter username',
  ENTER_PASSWORD: 'Enter password',
  PLEASE_ENTER_USERNAME: 'Please enter username',
  PLEASE_ENTER_PASSWORD: "'Please enter password'",
  SOMETHING_WENT_WRONG: 'Something went wrong',
  FORGOT_PASSWORD: ' Forgot Password',
  PLEASE_ENTER_EMAIL: 'Please enter email',
  PLEASE_ENTER_VALID_EMAIL: 'Please enter valid email',
  VEHCILE: 'Vehicles',
  LOADING: 'Loading',
  FORGOT_PASSWORD_SUBTITLE: `Enter your email address and we’ll send you an email with instructions to reset your
  password..!!`,
  ENTER_EMAIL: 'Enter email',
  SEND_LINK: 'Send link',
  SUCCESS: 'Success !',
  FORGOT_PASSWORD_SUCCESS_SUBTITLE: ` A email has been send to your email. Please check for an email from company and click on the
  included link to reset your password.`,
  BACK_TO_HOME: 'Back to home',
  FORGOT_PASSWORD_SUCCESS_MESSAGE: 'A reset password link has been sent to your email address',
  RESET_PASSWORD: 'Reset Password',
  RESET_PASS_SUBTITLE: `Enter new password to reset the password on your account. We’ll ask for this password
  whenever you log in..!`,
  PASS_VALIDATION_1: 'Must have at least one lowercase, uppercase, digit, and special character',
  PASS_VALIDATION_2: 'Must be at least 8 characters long',
  CONFIRM_PASSWORD: 'Confirm password',
  RESET_PASS_SUCCESS_MESSAGE: `Your password has been successfully reset. You can now log in to your account with your new
  password.`,
  RESET_PASSWORD_SUCCESS_TOAST: 'Password reset successfully',
  RESET_PASSWORD_ERROR_MESSAGE_1:
    'Please enter a valid password. password must have at least one lowercase, uppercase, digit, and special character. Minimum length of 8 characters and maximun length of 30 character',
  RESET_PASSWORD_ERROR_MESSAGE_2: 'Password and confirm password are not match',
  ADD_VEHICLE: 'Add vehicle',
  Edit_VEHICLE: 'Edit vehicle',
  ADD_VEHICLE_SUBTITLE: 'Get started by filling below information to add new vehicle',
  EDIT_VEHICLE_SUBTITLE: 'Get started by filling below information to edit new vehicle',
  ASSIGNED_USER: 'Assigned user',
  ASSOCIATED_COMPANY: 'Associate company',
  TIRE_SIZE_PLACEHOLDER: 'Enter tire size',
  ADD_TIRE_SIZE: 'Add Tire Size',
  ERROR_TIRE_SIZE_TOAST_MESSAGE: 'Please enter tire size',
  SUCCESS_TIRE_SIZE_UPDATED_TOAST_MESSAGE: 'Tire size updated successfully',
  SUCCESS_TIRE_SIZE_ADDED_TOAST_MESSAGE: 'Tire size added successfully',
  EDIT_TIRE_SIZE: 'Edit Tire Size',
  SUCCESS_TIRE_SIZE_DELETED_TOAST_MESSAGE: 'Tire size deleted successfully',
  DELETE_TIRE_SIZE: 'Delete Tire Size',
  DELETE_TIRE_SIZE_MESSAGE: 'Are you sure you want to delete {{name}} tire size?',
  TIRE_SIZE: 'Tire size',
  CREATED_ON: 'Created on',
  UPDATED_ON: 'Updated on',
  NODATA_TIRE_SIZE: 'There is no tire size created yet',
  EDIT: 'edit',
  REMOVE: 'remove',
  EDIT_MODEL: 'Edit Model',
  SUCCESS_MODEL_DELETED_TOAST_MESSAGE: 'Model deleted successfully',
  DELETE_MODEL: 'Delete Model',
  DELETE_MODEL_MESSAGE: 'Are you sure you want to delete {{name}} model?',
  NODATA_MODEL_CREATED: 'There is no model created yet',
  EDIT_ENGINE: 'Edit Engine',
  DELETE_ENGINE: 'Delete Engine',
  DELETE_ENGINE_MESSAGE: 'Are you sure you want to delete {{name}} engine?',
  SUCCESS_ENGINE_DELETED_TOAST_MESSAGE: 'Engine deleted successfully',
  ENGINE: 'Engine',
  NODATA_ENGINE_CREATED: 'There is no engine created yet',
  EDIT_DEVICE: 'Edit device',
  DELETE_DEVICE: 'Delete device',
  DELETE_DEVICE_MESSAGE: 'Are you sure you want to delete {{name}} device?',
  SUCCESS_DEVICE_DELETED_TOAST_MESSAGE: 'Device Provider deleted successfully',
  EDIT_DEVICE_PROVIDER: 'Edit Device Provider',
  DELETE_DEVICE_PROVIDER: 'Delete Device Provider',
  DELETE_DEVICE_PROVIDER_MESSAGE: 'Are you sure you want to delete {{name}} device provider?',
  SUCCESS_DEVICE_PROVIDER_DELETED_TOAST_MESSAGE: 'Device Provider deleted successfully',
  NODATA_DEVICE_PROVIDER_CREATED: 'There is no provider created yet',
  EDIT_BRAND: 'Edit Brand',
  DELETE_BRAND: 'Delete Brand',
  DELETE_BRAND_MESSAGE: 'Are you sure you want to delete {{name}} Brand?',
  SUCCESS_BRAND_DELETED_TOAST_MESSAGE: 'Brand deleted successfully',
  NODATA_BRAND_CREATED: 'There is no brand created yet',
  ORGANIZATION_NAME: 'Organization name',
  SAVE_SLOTS: 'Save Slots',
  REMOVE_SLOTS: 'Remove Slots',
  APPOINTMENT_DETAILS: 'Appointment Details',
  AVAILABILITY_SLOTS: 'Availability of Slots',
  APPOINTMENT_DESCRIPTION: 'Appointment Service Description',
  SUCCESS_SLOT_BOOK_TOAST_MESSAGE: 'Slot booking Successfully',
  ERROR_SLOT_BOOK_TOAST_MESSAGE: 'Please select slots',
  VEHICLE_BRAND: 'Vehicle Brand',
  DEALERBEST: 'Dealerbest',
  MOBILE_NO: 'Mobile no.',
  FISCAL_ADDRESS: 'Fiscal Address',
  VAT: 'VAT',
  PARKING: 'Parkings',
  COMPLETED: 'completed',
  URL_PLACEHOLER: 'Enter URL here',
  ALERT: 'Alert',
  BRAND: 'Brand',
  MODEL: 'Model',
  PLATE: 'Plate',
  STATUS: 'Status',
  ALL: 'All',
  DETAILS: 'Details',
  SEARCH: 'Search',
  ADD_NEW_VEHCILE: 'Add new vehicle',
  EXPORT_AS_DATA: 'Export as data',
  EXPORT_AS_TEMP: 'Export As template',
  EXPORT_VIN_TEMPLATE: 'Export Vin Template',
  VEHICLE_SEARCH_TOOLTIP_TEXT:
    'Search by Brand, Model, Plate, Chasis, Frame, Version, and Assigned User.',
  ALERT_SEARCH_TOOLTIP_TEXT: 'Search by Customer Name or Vehicle plate.',
  CAMPAIGN_AND_PROGRAMMED_EVENT_TOOLTIP_TEXT: 'Search by Reference code, Title and Description.',
  PAYMENT_SEARCH_TOOLTIP_TEXT: 'Search by Plate, Model and Customer email.',
  ADD_ORGANIZATION: 'Add Organization',
  EMPTY_VEHCILE_LIST_MESSAGE: 'There are no vehicles created yet',
  EMPTY_PAYMENT_LIST_MESSAGE: 'There are no payments created yet.',
  ORGANIZATION_NAME: 'Organization name',
  VEHICLE_FILTER_ERROR_MESSAGE_1: 'Registration enddate should greater than startdate',
  VEHICLE_FILTER_ERROR_MESSAGE_2: 'Purchase enddate should greater than startdate',
  VEHICLE_FILTER_ERROR_MESSAGE_3: 'End km should greater than start km',
  CLEAR_FILTER: ' Clear filters',
  FILTER_BY: 'Filter by',
  REG_FROM: 'Registration From',
  REG_TO: 'Registration To',
  PUR_FROM: 'Purchase From',
  PUR_TO: 'Purchase To',
  COMPANY: 'Company',
  ORGANIZATIONS: 'Organizaions',
  ASS_COMPANIES: 'Associated companies',
  TRANSMISSION: 'Transmission',
  CATEGORY: 'Category',
  ENGINE_TYPE: 'Engine type',
  FUEL_TYPE: 'Fuel type',
  FUEL_LEVEL: 'Fuel level',
  FUEL_LEVEL_PERCENTAGE: 'Fuel level (%)',
  FUEL_LEVEL_VOLUME: 'Fuel level (Vol)',
  BATTERY_LEVEL: 'Battery level',
  LAST_MONTH_AVERAGE: 'Last month average',
  LAST_UPDATED: 'Last updated',
  DOORS: 'Doors',
  PLACES: 'Places',
  ENV_LABLE: 'Environmental label',
  TIRE_SIZE: 'Tire size',
  FRONT_TIRE_SIZE: 'Front tire size',
  REAR_TIRE_SIZE: 'Rear tire size',
  KM_FROM: 'KM from',
  KM_TO: 'KM to',
  NEW_CAR_USED_CARS: 'New cars/Used cars',
  APPLY: 'Apply',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  CONFIRM: 'Confirm',
  USED_CARS: 'Used cars',
  NEW_CARS: 'New cars',
  GEOTAB_ADDED: 'Geotab Added',
  ADD_NEW_USER: 'Add new user',
  ADD_NEW_USER_SUBTITLE: 'Get started by filling below information to add new user',
  PLEASE_SELECT_BRAND: 'Please select brand',
  PLEASE_ENTER_MODEL: 'Please enter model',
  PLEASE_SELECT_REG_DATE: 'Please select registration date',
  PLEASE_SELECT_PUR_DATE: 'Please select purchase date',
  PLEASE_SELECT_ORG: 'Please select organization',
  PLEASE_SELECT_CAT: 'Please select category',
  PLEASE_SELECT_MODEL: 'Please select model',
  PLEASE_SELECT_PLATE: 'Please enter plate',
  PLEASE_ENTER_VIN: 'Please enter VIN',
  PLEASE_ENTER_TUTION: 'Please enter tuition',
  PLEASE_ENTER_FRAME: 'Please enter frame',
  PLEASE_ENTER_ENGINE: 'Please select engine',
  PLEASE_SELECT_FUELTYPE: 'Please select fuel type',
  PLEASE_SELECT_TRANSMISSION: 'Please select transmission',
  PLEASE_SELECT_TIRE_SIZE: 'Please select tire size',
  PLEASE_SELECT_FRONT_TIRE_SIZE: 'Please select front tire size',
  PLEASE_SELECT_REAR_TIRE_SIZE: 'Please select rear tire size',
  PLEASE_SELECT_STATUS: 'Please select status',
  PLEASE_ENTER_KM: 'Please enter km',
  PLEASE_ENTER_DEVICE_IMEI: 'Please enter device IMEI no.',
  PLEASE_SELECT_DEVICE_PROVIDER: 'Please select device provider',
  VEHCILE_UPDATE_SUCCESS_MESSAGE: 'Vehicle details updated successfully',
  VEHICLE_ADD_SUCCESS_MSG: 'Vehicle added successfully',
  NO_IMG: 'No image',
  SELECT_MODEL: 'Select model',
  REG_DATE: 'Registration date',
  PUR_DATE: 'Date of purchase',
  ORG_DETAILS: 'Organization details',
  SELE_ORG: 'Please select organization',
  ASSIGN_USR: 'Assigned user',
  OPTIONAL: 'Optional',
  SELECT_ASSIGNED_USR: 'Select Assigned User',
  EMPTY_PARK_ADD_MSG: 'No parking address added',
  PLEASE_SEL_ASS_COM: 'Please select associate company',
  CAT_ORG: 'Category / Origin',
  SEL_CAT_ORG: 'Select Category/Origin',
  SEL_TYPE: 'Select type',
  TYPE: 'Type',
  ENTER_PLATE: 'Enter plate',
  VIN: 'VIN',
  ENTER_VIN: 'Enter VIN',
  KM: 'Km',
  ENTER_KM: 'Enter km',
  SEL_ENGINE: 'Select engine',
  SEL_TIRE_SIZE: 'Select front tire size',
  SEL_REAR_TIRE_SIZE: 'Select rear tire size',
  TUTION: 'Tution',
  ENTER_TUTION: 'Enter tution',
  FRAME: 'Frame',
  ENTER_FRAME: 'Enter frame',
  DEVICE: 'device',
  PROVIDER_NAME: 'Provider Name',
  DEVICE_PROVIDER: 'Device provider',
  SEL_DEVICE_PROVIDER: 'Select device provider',
  Device_IMEI: 'Device IMEI',
  ENTER_DEVICE_IMEI: 'Enter device imei no.',
  VERSION: 'Version',
  ENTER_VERSION: 'Enter version',
  ENTER_DOORS: 'Enter doors',
  ENTER_PLACES: 'Enter places',
  NEW_CAR_OR_USED_CAR: 'New car or Used car',
  SEL_ENV_LABEL: 'Select environmental label',
  ORG: 'Organization',
  SAVE_CHANGES: 'Save changes',
  ADDRESS_1: 'Address 1',
  PARKING_HEADQUATERS: 'Parking / Headquarters',
  LAST_UPDATE_KM_DATE: 'Last updated km Date',
  POLICY_EXP_DATE: 'Policy expiration Date',
  INS_POLICY_NO: 'Insurance Policy no.',
  DTC_ALERTS: 'DTC Alerts',
  dtc: {
    tableHeaders: {
      dtcCode: 'DTC Code',
      createdAt: 'Created At',
      faultDescription: 'Fault Description',
    },
  },
  VEHICLE_INFO: 'Vehicle information',
  ALERTS: 'Alerts',
  APPOINTMENTS: 'Appointments',
  EDIT_DETAILS: 'Edit Details',
  KM_Updated_AT: 'KM updated at',
  DATE_FORMAT_LONG_WITH_TIME: 'MMMM DD, YYYY [at] HH:mm',
  DATE_FORMAT_SHORT_WITH_TIME: 'MMM DD, YYYY [at] HH:mm',
  DATE_FORMAT_LONG: 'MMMM DD, YYYY',
  DATE_FORMAT_MONTH_YEAR: 'MMMM YYYY',
  NO_USERS: 'No users',
  NOTIFY_USERS: 'Notify users',
  FILE_SIZE: 'Max File size : 25 MB',
  FILE_TITLE: 'Upload Photo/Video',
  DATE_PLACEHOLDER: 'DD/MM/YYYY',
  CHOOSE_FILE: 'Choose file',
  NO_FILE_CHOSEN: 'No file chosen',
  SEARCH_PLACEHOLDER: 'Type to search...',
  BACK_HOME: 'Back Home',
  CHECK_BACK_LATER: 'Check back later',
  WORK_IN_PROGESS: 'Work in Progress',
  LOADING: 'Loading...',
  NO_OPTION: 'No option',
  NO_RESULT_FOUND: 'No result found',
  Notification: 'Notification',
  NO_NOTIFICATION: 'No Notifications',
  APPOINTMENT_REQUEST: 'You got a new appointment request please schedule your availability',
  ERROR_ACCESS_SLOT_AVAILIBILITY: 'You have no right to access slot availibility functionality.',
  ERROR_ACCESS_SLOT_CONFIRMATION: 'You have no right to access slot confirmation functionality.',
  LOGOUT: 'Logout',
  PROFILE: 'Profile',
  ACTIVE: 'Active',
  EXPORT: 'Export',
  ADDRESS1: 'Address line 1',
  ADDRESS2: 'Address line 2',
  tips: 'Tips',
  offer: 'Offer',
  Active: 'Active',
  completed: 'Completed',
  PAIT: 'Paid',
  Canceled: 'Canceled',
  not_paid: 'Not Paid',
  alert: 'Alert',
  PENDING: 'Pending',
  in_progress: 'In Progress',
  IN_PROGRESS: 'In Progress',
  CANCELED: 'Canceled',
  warning: 'Warning',
  super_admin: 'Super Admin',
  sleep: 'Sleep',
  offer: 'offer',
  PAGE: 'Page',
  OF: 'of',
  SCHEDULED: 'Scheduled',
  SENT: 'Sent',
  dealer_admin: 'Dealer Admin',
  fleet_manager: 'Fleet Manager',
  call_center: 'Call Center',
  new_used_car: 'New Car or Used Car',
  purchase_date: 'Purchase date',
  vin_number: 'Type vin number to search...',
  WORKSHOP_APPOINTMENTS_DETAILS: {
    title: 'Workshop Appointments Details',
  },
  appointments: {
    pageTitle: 'Appointments',
    tableHeaders: {
      dateAndTime: 'Appointment Date & Time',
      serviceType: 'Service Type',
      description: 'Description',
      specialNotes: 'Special Notes',
    },
    noDataMessage: 'No appointment data',
  },
  mediaList: {
    tableHeader: {
      media: 'Photo/Video',
      type: 'Type',
      mediaBeforeService: 'Media Before Service',
      mediaAfterService: 'Media After Service',
    },
    noDataMessage: 'No Attachments available.',
  },
  companies: {
    pageTitle: 'Companies',
    searchPlaceholder: 'Search By Name',
    primaryButtonLabel: 'Add Company',
    successCompanyDeletedToastMessage: 'Company deleted successfully.',
    noDataMessage: 'There is no company create yet',
    tableHeaders: {
      name: 'Name',
      fiscal_number: 'Fiscal number',
      activity: 'Activity',
      headquarters: 'Headquarter',
      other_stations: 'Other stations',
    },
    editModel: {
      title: 'Edit Company',
      subtitle: 'Get started by filling below information to edit company',
    },
    addModel: {
      title: 'Add Company',
      subtitle: 'Get started by filling below information to add new compnay',
    },
    deleteModel: {
      title: 'Delete Company',
      message: `Are you sure you want to delete {{companyName}} company?`,
    },
    add_edit: {
      headquarter_address: 'Headquarter Address',
      noaddressmessage: 'No stations address added',
      addressline: 'Address {{index}}',
      save_changes: 'Save Changes',
      add_station: 'Add station',
      add_company: 'Add Company',
      postalCode: 'Postal Code',
      city: 'City',
      state: 'State',
      country: 'Country',

      name_message: 'Please enter name',
      fiscal_number_message: 'Please enter fiscal number',
      activity_message: 'Please enter activity',
      headquarter_address_message: 'Please enter headquarter address',
      success_add_toast_message: 'Company added successfully',
      success_update_toast_message: 'Company updated successfully',
      error_address_toast_message: 'Please enter station addressline 1',
      error_country_toast_message: 'Please select staion country',
      error_state_toast_message: 'Please select station state',
      error_city_toast_message: 'Please select station city',
      error_zipcode_toast_message: 'Please enter parking address zipcode',
    },
  },
  workshopAppointment: {
    pageTitle: 'Workshop Appointments',
    fleetRole: 'Req For Workshop App',
    otherRole: 'Book Workshop App',
    bookNowBtn: 'Book Now',
    bookAppointment: 'Book an Appointment',
    successAppointmentBookToastMessage: 'Workshop appointment booked successfully',
    errorTimeslotToastMessage: 'Please select timeslot',
    noDataMessage: 'No workshop created yet',
    successBrandAddedToastMessage: 'Brand added successfully',
    successBrandUpdatedToastMessage: 'Brand updated successfully',
    errorBrandNameToastMessage: 'Please enter brand name',
    uploadLogo: 'Upload Logo',
    changeLogo: 'Change logo',
    brandNamePlaceholder: 'Enter brand name',
    tooltipText: 'Search by customer name, vehicle model or brand name',

    tableHeaders: {
      invoice_pdf: 'Invoice PDF',
      Photos_video: 'Photos/Video',
      slot: 'Appointment date & time',
      service_type: 'Service type',
      user_details: 'Customer name',
      brand_name: 'Brand name',
      model_name: 'Vehicle model',
    },
    BookWorkshopAppointment: {
      title: 'Create Appointment',
    },
    WorkshopAppointmentRequest: {
      title: 'Workshop Appointment Request',
    },
    EditWorkshopAppointment: {
      title: 'Edit Appointment',
    },
    menuOptions: {
      mark_as_reject: 'Mark as Reject',
      view_details: 'View Details',
      edit: 'Edit',
      in_progress: 'In Progress',
      mark_as_complete: 'Mark as Complete',
    },
    requestsTab: 'Workshop Requests',
    calendar: {
      list: 'List',
      calendarView: 'Calendar',
      today: 'Today',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      noAppointments: 'No appointments',
      noAppointmentsForDay: 'No appointments scheduled for this day',
      noEvents: 'No events',
      moreEvents: '+{{count}} more',
    },
    slots: {
      addSlots: 'Add Slots',
      slotDetails: 'Slot Details',
      editSlot: 'Edit Slot',
      deleteSlot: 'Delete Slot',
      startTime: 'Start Time',
      endTime: 'End Time',
      time: 'Time Range',
      availability: 'Availability',
      noRepeat: 'Does not repeat',
      repeatWeekly: 'Repeat weekly',
      organisation: 'Organisation',
      parking: 'Parking',
      totalWorkshops: 'Workshops per slot',
      date: 'Date',
      save: 'Save',
      cancel: 'Cancel',
      slotCreated: 'Slot created successfully',
      slotUpdated: 'Slot updated successfully',
      slotDeleted: 'Slot deleted successfully',
      overlapError: 'A slot already exists for this parking at the selected date and time',
      deleteWarning: 'There are {{count}} workshop appointments scheduled for this slot. Are you sure you want to delete?',
      deleteSlotConfirm: 'Are you sure you want to delete this slot?',
      deleteReason: 'Delete Reason',
      deleteReasonPlaceholder: 'Type reason for deleting this slot',
      deleteReasonRequired: 'Please enter a reason for deleting this slot',
      decreaseError: 'Cannot decrease below {{count}} (currently booked workshops)',
      capacity: '{{booked}}/{{total}} workshops',
      bookedCapacity: 'Booked / Capacity',
      filterOrganisation: 'Select Organisation',
      parkingDetails: 'Parking: {{name}}',
      noSlots: 'No slots created',
      confirmDelete: 'Confirm Delete',
      workshopsBooked: '{{count}} workshops booked',
      selectDate: 'Select date',
      selectStartTime: 'Select start time',
      selectEndTime: 'Select end time',
      selectOrganisation: 'Select organisation',
      selectParking: 'Select parking',
      selectTime: 'Please select start and end time',
      enterWorkshopCapacity: 'Enter number of workshops',
      endTimeError: 'End time must be after start time',
      noSlotsForDate: 'No available slots for this date',
      bookedInCar: 'Booked in CAR',
      selectVehicleFirst: 'Select a vehicle to see available slots',
    },
    process: 'Process',
    view: 'View',
    date: 'Date',
    user: 'User',
    title: 'Title',
    description: 'Description',
    action: 'Action',
    noRequestsMessage: 'No workshop requests found',
    newRequestsPopupTitle: 'New Workshop Requests',
    newRequestsPopupMessage: 'There are {{count}} new workshop requests. Would you like to view them now?',
    yes: 'Yes',
    no: 'No',
    ExpandedUi: {
      customer_email: 'Customer email',
      customer_phone: 'Customer phone',
      customer_license_number: 'Customer licence number',
      vehicle_plate: 'Vehicle plate',
      vehicle_vin: 'Vehicle VIN',
      associated_Company: 'Associated company',
      notes: 'Special requests or Notes',
      service_description: 'Service description',
      car_replacement: 'Car replacement',
      vehicle_version: 'Vehicle Version',
      vehicle_year: 'Vehicle Year',
      no_note: 'No Note',
      media: 'Media Attachments',
      reject_reason: 'Reject Reason',
    },
    add_edit: {
      title: 'Customer & Vehicle Details',
      vehicle: 'Vehicle',
      alert: 'Alerts',
      service_type: 'Other Service Type',
      service_description: 'Service Description',
      customer: 'Customer',
      phone: 'Phone Number',
      schedule: 'Schedule',
      note: 'Special Request or note (optional)',
      replace_Car: 'Want a replacement of car?',
      appointment_timeslot: 'Select Appointment Timeslots',
      appointment_date: 'Selected Appointment Date & Time',
      placeholder_service_type: 'Enter other service type... ',
      placeholder_vehicle: 'Select Vehicle',
      placeholder_alert: 'Select alerts',
      placeholder_customer: 'Customer Name',
      placeholder_email: 'Customer Email Address',
      placeholder_note: 'Special Request or note',
      error_appointment_toast_message: 'Please select appointment date and time',
      error_other_service_toast_message: 'Please enter other service type',
      error_customer_toast_message: 'Please select customer',
      error_alert_toast_message: 'Please select alert',
      error_service_description: 'please enter service description',
      success_appointment_updated_toast_message: 'Workshop appointment updated successfully',
      success_appointment_created_toast_message: 'Workshop appointment created successfully',
      success_appointment_completed_toast_message: 'Workshop appointment completed successfully',
    },
    device_provider: {
      devicePlaceholder: 'Enter device provider',
      errorDeviceProviderNameToastMessage: 'Please enter device provider name',
      successDeviceProviderNameUpdatedToastMessage: 'Device provider updated successfully',
      successDeviceProviderNameAddedToastMessage: 'Device provider added successfully',
    },
    steps: {
      uploadInvoiceImageLabel:
        'Upload invoice or replace parts images/videos/files for appointment details and future reference.',
      uploadFileTitle: 'Photo/Video/PDF',
      notesLabel: 'Notes (Optional)',
      notesPlaceholder: 'Enter notes...',
      complete: 'Complete',
      paymentConfirmation: 'PAYMENT_CONFIRMATION',
      time: 'Time',
      createPayment: 'Do you want to create payment for this workshop appointment?',
      paymentConfirmationlabel: 'Payment Confirmation',
      createPaymentLabel: 'Create Payment',
      uploadInvoiceAppointmentLabel: 'Upload invoice for appointment details and future reference.',
      customerName: 'Customer Name',

      brandPlaceholder: 'Select Brand',

      modelPLaceholder: 'Enter Model',
      amount: 'Amount',
      amountPlaceholder: 'Enter Amount',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Enter Description...',
      successPaymentToastMessage: 'Payment created successfully.',
      errorAmountMessage: 'Please enter amount',
    },
    success_appointment_request_send_toast_message:
      'Workshop appointment request send successfully',
    cancelled: {
      rejectTitle: 'Appointment Rejected',
      reason: 'Reason',
      reasonPlaceholder: 'Type reason for rejecting appointment',
      primaryButtonLabel: 'Reject it',
      errorResonToastMessage: 'Please enter reason',
      successRejectToastMessage: 'Workshop appointment rejected successfully ',
    },
    changeStatus: {
      changeStatusTitle: 'Change Appointment Status',
      changeStatusSubTitle: 'Do you want to change status from ',
      to: 'to',
      inProgress: 'In Progress',
      successChangeStatusToastMessage: 'Appontment status changed successfully',
    },
    saveChanges: 'Save Changes',
    addBrand: 'Add Brand',
    addModel: 'Add Model',
    deviceProvider: 'Device Provider',
    addDeviceProvider: 'Add Device Provider',
    deviceProviderPlaceholder: 'Select Device Provider',
    addDevice: 'Add Device',
    deviceIMEI: 'Device IMEI No.',
    errorDeviceToasterMessage: 'Please select device provider',
    errorIMEIToasterMessage: 'Please enter device IMEI number',
    successDeviceUpdateToastMessage: 'Device updated successfully',
    successDeviceCreateToastMessage: 'Device created successfully',
    engine: 'Engine',
    enginePlaceholder: 'Enter Engine',
    addEngine: 'Add Engine',
    succesEngineAddedToastMessage: 'Engine added successfully',
    succesEngineUpdatedToastMessage: 'Engine updated successfully',
    errorEngineToastMessage: 'Please enter engine',
    errorSelectBrandToastMessage: 'Please select brand',
    errorModelNameToastMessage: 'Please enter model name',
    successModelUpdatedMessage: 'Model updated successfully',
    successModelCreatedSuccessfully: 'Model created successfully',
  },
  alerts: {
    pageTitle: 'Alerts',
    tableHeaders: {
      alertTitle: 'Alert Title',
      dateAndTime: 'Date & Time',
      description: 'Description',
      referanceCode: 'Reference code',
      referanceCodePlaceholder: 'Enter reference code',
      timeLeftInDays: 'Days Left',
    },
    alert_template_btn: 'Alerts Templates',
    campaigns: 'Campaigns',
    alert_Campaigns: 'Alerts & Campaigns',
    noDataMessage: 'No alerts generated yet',
    alertCompleteSuccess: 'Alert completed successfully',
    completeAlertTitle: 'Complete Alert',
    completeAlertConfirmation: 'Are you sure you want to complete {{alertTitle}} alert?',
    createAlert: 'Create Alert',
    createCampaign: 'Create Campaign',
    programmed_alerts: 'Programmed Alerts',
    noAlertTemplateCreated: 'No alert template created yet',
    alertupdateKm: 'Alert update km',
    enterKm: 'enterKm',
    alertUpdateDate: 'Alert update date',
    saveChanges: 'Save Changes',
    markAsComplete: 'Mark as complete',
    editAlert: 'Edit alert',
    alertEditSuccess: 'Alert edited successfully',
    kmVal: 'Km value',
  },
  generated_alert: {
    tableHeaders: {
      title: 'Title',
      customer_name: 'Customer name',
      customer_number: 'Customer number',
      customer_email: 'Customer email',
      vehicle_plate: 'Vehicle plate',
      description: 'Description',
      descriptionPlaceholder: 'Alert description',
      noDataMessage: 'No alerts are send yet.',
    },
  },
  campaigns: {
    tableHeaders: {
      alert_ref: 'Reference code',
      title: 'Title',
      description: 'Description',
      user_count: 'User Count',
    },
    placeholder_brand: 'Select brand ',
    placeholder_model: 'Select model',
    placeholder_engine: 'Select engine',
    placeholder_front_tire: 'Select front tire size',
    placeholder_rear_tire: 'Select rear tire size',
    placeholder_tire_size: 'Select tire size ',
    placeholder_title: 'Campaign title',
    placeholder_description: 'Enter descripton...',
    campaign_title: 'Campaign Title',
    csv_upload: 'Upload CSV file with vehicle VIN numbers',
    publish_campaign_btn: 'Publish campaign',
    title_error_message: 'Please enter campaign title',
    description_error_message: 'Please enter description',
    referanceCode_error_message: 'Please enter reference code',
    noDataMessage: 'No campaigns are published yet',
  },
  programmed_alerts: {
    active_inactive: 'Active/Inactive',

    noDataMessage: 'No programmed alert created yet.',
    conditions: 'Conditions',
    conditionPlaceholder1: 'Select field',
    conditionPlaceholder2: 'Select condition',
    primaryButtonLabel: 'Add new condition',
    errorConditionToastMessage: 'Please fill previous conditions value',
    darkBtnLabel: 'Save As Template',
    editAlert: 'Edit alert',
    createAlert: 'Create alert',
    conditionValueKM: 'Enter milege',
    conditionValueTime: 'Enter days',
    conditionValueDefault: 'Enter value',
    errorRefCodeToastMessage: 'Please enter alert ref code',
    errorAlertDescToastMessage: 'Please enter alert description',
    errorAlertTitleToastMessage: 'Please enter alert title',
    errorAlertToastMessage: 'Please enter alert title and description',
    successAlertUpdateToatMessage: 'Programmed alert update successfully',
    successAlterCreateToastMessage: 'Programmed alert create successfully',
  },
  administrator_roles: {
    title: 'Administrator Roles ({{adminRoles}})',
    searchPlaceholder: 'Search',
    addUser: 'Add User',
    searchTooltipText: 'Search by name, surname & email',
    add_title: 'Add new Administrator Role',
    add_subtitle: 'Get started by filling below information to add new admin role',
    edit_title: 'Edit Administrator Role',
    edit_subtitle: 'Get started by filling below information to edit administrator role',
    delete_title: 'Delete Administartor Role',
    delete_message: 'Are you sure you want to delete {{userData}} user?',
    successDeleteToastMessage: 'Admin user deleted successfully',
    noDataMessage: 'There is no Administrator role created yet',
    tableHeaders: {
      name: 'Name',
      last_name: 'Surname',
      email: 'Email',
      emailPlaceholder: 'Email address',
      role: 'Role',
    },
    addEdit: {
      addGeotab: 'Add Geotab',
      username: 'Username',
      password: 'Password',
      databasePlaceholder: 'database name',
      usernamePalceholder: 'username',
      passwordPlaceholder: 'password',
      assignRole: 'Assign Role',
      assignRolePlaceholder: 'Please select role',
      associateCompany: 'Associate Company',
      associateCompanyPlaceholder: 'Please select company ',
      organizationDetail: 'Organization details',
      organization: 'Organization',
      organizationPlaceholder: 'Please select organization',
      selectAll: 'Select All',
      saveChanges: 'Save Changes',
      addUser: 'Add User',
      add: 'Add',
      noOrganization: 'No organizations are added',
      errorNameMessage: 'Please enter name',
      errorSurname: 'Please enter surname',
      errorEmail: 'Please enter email',
      errorValidEmail: 'Please enter valid email',
      errorOrganizationDetailToastMessage: 'Please enter organization details',
      errorAssociateCompany: 'Please select associate company',
      errorOrganizationToastMessage: 'Please select organization',
      errorParkingAddressToastMessage: 'Please select parking address',
      successAddToastMessage: 'Administrator role added successfully',
      successUpdateToastMessage: 'Administrator role updated successfully',
    },
    address: 'Address {{index}}',
    noParkingAddress: 'No Parking Addresses are added',
  },
  map: {
    title: 'Map',
    searchPlaceholder: 'Search by plate number',
    customer: 'Customer',
  },
  satisfactionSurvey: {
    title: 'Satisfaction Surveys',
    searchPlaceholder: 'Search by client name',
    primaryButtonLabel: 'Add Survey',
    tabs: {
      surveyTemplates: 'Survey Templates',
      surveyFeedbacks: 'Survey Feedbacks',
    },
    tableHeaders: {
      surveyTitle: 'Survey Title',
      surveyType: 'Survey launch at',
      createdAt: 'Date & Time',
      customerName: 'Customer name',
      customerEmail: 'Customer Email',
      telephone: 'Telephone',
      status: 'Status',
      view: 'View',
      noOfQuestions: 'No. of Questions',
      is_activated: 'Active/Inactive',
    },
    feedBackTitle: 'Survey Feedback Details',
    pendingToastMessage:
      'The client has not filled the satisfaction survey. Please contact him/her.',
    deleteTitle: 'Delete Survey',
    deleteMesaage: 'Are you sure you want to delete {{survey}} survey?',
    successDeleteToastMessage: 'Survey deleted successfully',
    noDataMessage: "There are no survey's responses available.",
    export: {
      question: 'Question',
      rating: 'Rating',
      feedbackDate: 'Feedback Date',
    },
    surveyDetails: {
      errorQuestionToastMessage: 'Please enter question',
      errorSurveyTitleToastMessage: 'Please enter survey title',
      errorAddQuestionToastMessage: 'Please add questions',
      errorSurveyTypeToastMessage: 'Please select launch survey',
      surveyEdit: 'Survey Details',
      surveyAdd: 'Survey Creation',
      saveTemplate: 'Save as a Template',
      surveyTitle: 'Survey Title',
      surveyTitlePlaceholder: 'Give title to your survey',
      launchSurvey: 'Launch Survey',
      launchSurveyPlaceholder: 'Select launch survey',
      brand: 'Brands',
      brandPlaceholder: 'Select brands',
      noDataMessage: 'No questions added yet',
      questionPlaceholder: 'Type your question here...',
      primaryButtonLabel: 'Edit question',
      addNewQuestion: 'Add new question',
      addNewQuestionPlaceholder: 'Type your question here...',
      saveChanges: 'Save Changes',
      createSurvey: 'Create Survey',
      remark: 'Remark',
    },
  },
  users: {
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    mobileNo: 'Telephone',
    dateOfBirth: 'Date of birth',
    address: 'Address',
    action: '',
    title: 'Users',
    addUser: 'Add user',
    searchPlaceholder: 'Search',
    searchTooltipText: 'Search by name, surname & email',
    noUsersMessage: 'No users created yet',
    assignedVehicles: 'Assigned vehicle/s',
    associateCompany: 'Associate company',
    dni: 'DNI',
    dniExpDate: 'DNI exp. date',
    licenseNo: 'License no.',
    licenseExpDate: 'License exp. date',
    policyNo: 'Policy no.',
    policyExpDate: 'Policy exp. date',
    billingAddress: 'Billing address',
    commercialCommunication: 'Commercial Communication',
    organization: 'Organization',
    selectVehicles: 'Please select vehicles',
    dniNo: 'DNI No.',
    expDate: 'Expiry date',
    enterEmail: 'Please enter email',
    enterValidEmail: 'Please enter valid email',
    enterPhone: 'Please enter telephone number',
    enterName: 'Please enter name',
    enterSurname: 'Please enter surname',
    enterLicenseNo: 'Please select licence exp date',
    fillAddressData: 'Please fill all address data',
    fillBillingAddressData: 'Please fill all billing address data',
    DNIDetails: 'DNI details add by user in the app',
    eightDigitNo: '8 digit no.',
    drivingLicenceDetails: 'Driving license details',
    enterLicenceNo: 'Enter licence no.',
    insuranceDetails: 'Insurance data Details',
    typeOfPurchase: 'Type of purchase',
    selectPurchaseType: 'Please select purchase type',
    city: 'City',
    state: 'State',
    country: 'Country',
    postalCode: 'Postal code',
    import: 'Import',
    editUser: 'Edit User',
    editUserSubtitle: 'Get started by filling below information to edit user',
    successUserDeletedToastMessage: 'User deleted successfully',
    deleteUser: 'Delete User',
    deleteUserSubtitle: 'Are you sure you want to delete {{name}} user?',
    addUser: 'Add New User',
    deleteUserSubtitle: 'Get started by filling below information to add new user',
  },
  common: {
    confirmation: 'Are you sure you want to delete {{user}} user?',
    deleteSuccess: 'User deleted successfully',
  },
  organization: {
    title: 'Organizations',
    add: 'Add organization',
    edit: 'Edit organization',
    remove: 'Remove organization',
    searchPlaceholder: 'Search',
    noDataMessage: 'No organization created yet',
    noResultFoundMessage: 'No results found',
    add_title: 'Add organization',
    add_subtitle: 'Get started by filling below information to add new organization',
    edit_title: 'Edit Organization',
    edit_subtitle: 'Get started by filling below information to edit organization',
    'deleteConfirmation.title': 'Delete Organization',
    'deleteConfirmation.message':
      'Are you sure you want to delete {{organizationName}} organization?',
    deleteSuccessMessage: 'Organization deleted successfully',
    searchTooltipText: 'Search by org name, fiscal name & email',
    'columns.organization_name': 'Organization name',
    'columns.logo_fiscal_name': 'Logo & Fiscal name',
    'columns.email': 'Email',
    'columns.telephone': 'Telephone',
    'columns.fiscal_number': 'Fiscal number',
    'columns.tax_address': 'Tax address',
    'columns.actions': '',
    errors: {
      organization_name: 'Please enter organization name',
      email_required: 'Please enter email',
      invalid_email: 'Please enter valid email',
      fiscal_name_required: 'Please enter fiscal name',
      fiscal_number_required: 'Please enter fiscal number',
      vat_required: 'Please enter vat',
      telephone_required: 'Please enter telephone number',
      invalid_telephone: 'Please enter valid telephone number',
      address_required: 'Please enter address',
      invalid_concessionaire: 'Please enter valid concessionaire',
      key_required: 'Please enter key',
      car_user_name_required: 'Please enter CAR username',
      car_password_required: 'Please enter CAR password',
      secret_required: 'Please enter secret',
      resource_required: 'Please enter resource',
      parking_address_title_required: 'Please enter parking address title',
      parking_address_line1_required: 'Please enter parking addressline 1',
      parking_address_country_required: 'Please select parking address country',
      parking_address_state_required: 'Please select parking address state',
      parking_address_city_required: 'Please select parking address city',
      parking_address_zipcode_required: 'Please enter parking address zipcode',
      privacy_policy_url: 'Please provide valid url',
    },
    messages: {
      organization_added: 'Organization added successfully',
      organization_updated: 'Organization updated successfully',
    },
    labels: {
      upload_image: 'Upload Image',
      change_image: 'Change Image',
      organization_name: 'Organization Name',
      key: 'Key',
      secret: 'Secret',
      resource: 'Resource',
      database_name: 'Database Name',
      car_solution: 'CAR (Cloud Active Reception)',
      use_car: 'Use CAR for workshop slots',
      car_user_name: 'CAR username',
      car_password: 'CAR password',
      car_branch_id: 'CAR branch ID',
      api_key: 'Api key',
      fiscal_name: 'Fiscal Name',
      fiscal_number: 'Fiscal No.',
      email: 'Email',
      telephone: 'Telephone',
      address: 'Address',
      address_line1: 'Address line 1',
      address_line2: 'Address line 2',
      country: 'Country',
      state: 'State',
      city: 'City',
      postal_code: 'Postal code',
      parking_address: 'Parking Address',
      concessionaire_contact: 'Concessionaire Contact (URL)',
      save_changes: 'Save Changes',
      add_address: 'Add Address',
      no_parking_address: 'No parking address added',
      payment_keys: 'Payment keys',
      database: 'Database Information',
      title: 'Address Title',
      privacy_policy_url: 'Privacy Policy url',
    },
    placeholders: {
      organization_name: 'Organization Name',
      key: 'Key',
      secret: 'Secret',
      resource: 'Resource',
      database_name: 'Database name',
      car_user_name: 'Enter CAR username',
      car_password: 'Enter CAR password',
      car_branch_id: 'CAR branch ID (optional)',
      api_key: 'Api key',
      fiscal_name: 'Fiscal name',
      fiscal_number: 'Enter fiscal no.',
      email_address: 'Email address',
    },
  },
  payments: {
    title: 'Payments',
    tableHeaders: {
      customerName: 'Customer Email',
      slotDetails: 'Appointment Date & Time',
      serviceType: 'Service Type',
      amount: 'Amount',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Enter Description',
      brandDetails: 'Brand',
      modelDetails: 'Model',
      plate: 'Plate',
      created_at: 'Billing Date',
      payment_status: 'Status',
      confirm: 'Confirm',
    },
    primaryButtonLabel: 'Add Payment',
    addPayment: {
      errorAmountToastMessage: 'Please enter amount',
      errorSelectUserToastMessage: 'Please select users',
      errorWorkshopToastMessage: 'Please select workshop',
      successPaymentCreatedToastMessage: 'Payment created successfully',

      paymentTitle: 'Add Payment',
      createPaymentLabel: 'Do you want create payment for workshop appointment',
      uploadInvoiceLabel: 'Upload invoice for appointment details and future reference.',
      fileTitle: 'Upload File',
      workshopLabel: 'Workshop Appointment',
      workshopPlaceholder: 'Select workshop appointment',
      customerLabel: 'Customer',
      customerPlaceholder: 'Select customer',
      vehicleLabel: 'Vehicle',
      vehiclePlaceholder: 'Select Vehicle',
      amountPlaceholder: 'Enter Amount',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Enter description...',
      confirm: 'Confirm',
    },
  },
  offersAndTips: {
    pageTitle: 'Offers & Tips',
    primaryButtonLabel: 'Create offers & tips',
    tableHeaders: {
      title: 'Title',
      sentAt: 'Sent on',
      organizationDetails: 'Organizations',
      isNotification: ' Send via notification',
      isEmail: 'Send via email',
      type: 'Type',
      viewNotify: 'View notify users',
      sendAgain: 'Send again',
    },
    successOfferResentToastMessage: 'Offer resent successfully',
    scheduled: 'Scheduled',
    sent: 'Sent',
    addEdit: {
      saveChanges: 'Save Changes',
      create: 'Create',
      titlePlaceholder: 'Enter title',
      organizationPlaceholder: 'Select organizations',
      sendAt: 'Send At',
      typePlaceholder: 'Select Type',
      uploadPdf: 'Upload Pdf',
      addDesc: 'Add Description',
      brandPlaceholder: 'Select brand',

      enginePlaceholder: 'Select engine',
      frontTirePlaceholder: 'Select front tire size',
      rearTireplaceholder: 'Select rear tire size',
      sendOfferTips: 'Send offer and tips via',
      pushNotification: 'Push notification',
      mail: 'Mail',
      errorOfferSendToastMessage: 'Please atleast one option for send offer',
      errorContentTextMessage: 'Please enter content text',
      errorTypeToastMessage: 'Please select type',
      errorPublishTimeToastMessage: 'Please select publish time',
      errorPublishDateToastMessage: 'Please select publish date',
      errorSelectOrganizationToastMessage: 'Please select organization',
      errorTitleToastMessage: 'Please enter title',
      successOfferCreated: 'Offer created successfully',
    },
  },
  dms_Integartion: {
    add: 'Add',
    next: 'Next',
    back: 'Back',
    errorBillingAddressToastMessage: 'Please fill all billing address data',
    errorallAddressToastMessage: 'Please fill all address data',
    environmentalLabel: 'Please select environmental label',
    licenseNo: 'Please enter licence no.',
    telephoneNo: 'Please enter telephone number',
    errorFetchingDMS: 'Something went wrong while fetching data from DMS',
    namePlaceholder: 'Enter name',
    errorVINumberToastMessage: 'Please enter vin number.',
    errorName: 'Please enter name',
    errorSurname: 'Please enter surname',
    VEHICLE_DETAILS: 'Vehicle details',
    USER_DETAILS: 'User details',
    errorNoVehicleMessage: 'No vehicle found yet',
  },
  sidebarListItem: {
    VEHICLES: 'Vehicles',
    USERS: 'Users',
    ORGANIZATIONS: 'Organizations',
    COMPANIES: 'Companies',
    WORKSHOP_APPOINTMENTS: 'Workshop appointments',
    ALERTS_CAMPAIGN: 'Alerts & Campaigns',
    ADMINISTRATOR_ROLES: 'Administrator roles',
    MAP: 'Map',
    SATISFACTION_SURVEYS: 'Satisfaction surveys',
    BILLING: 'Payments',
    VEHICLE_CONFIG: 'Vehicle configurations',
    Offer_AND_TIPS: 'Offers & Tips',
  },
  initFilter: {
    PENDING: 'PENDING',
    SCHEDULED: 'SCHEDULED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED',
  },
  NotificationType: {
    completed: 'completed',
    warning: 'warning',
    sleeping: 'sleeping',
    alert: 'alert',
  },
  userRoles: {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    DEALER_ADMIN: 'dealer_admin',
    CLIENT: 'client',
    FLEET_MANAGE: 'fleet_manager',
    CALL_CENTER: 'call_center',
  },
  vehicleConfig: {
    brands: 'Brands',
    engines: 'Engines',
    'tire-sizes': 'Tire Sizes',
    'device-providers': 'Device Providers',
  },
  DATE_AT: 'at',
  months: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
  weekday: {
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thr: 'Thr',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
  },
};
